import { render, staticRenderFns } from "./userBigData.vue?vue&type=template&id=c843614a&scoped=true"
import script from "./userBigData.vue?vue&type=script&lang=js"
export * from "./userBigData.vue?vue&type=script&lang=js"
import style0 from "./userBigData.vue?vue&type=style&index=0&id=c843614a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c843614a",
  null
  
)

export default component.exports